import { LocalStorage } from '@kulee/helper'

class AdRequestRate {
  private WHITE_TOTAL = 10000
  private WHITE_NUMBER_KEY_PREFIX = 'TGA-AD-WHITE-'

  private adtype: AdType

  constructor(adtype: AdType) {
    this.adtype = adtype
  }

  public run(rate = 1): boolean {
    const requestNumMax = rate * this.WHITE_TOTAL
    const key = this.getKey()
    let myNum = LocalStorage.getItem(key)

    if (!myNum) {
      const randomNum = this.getRandomInt(1, this.WHITE_TOTAL)
      LocalStorage.setItem(key, randomNum)
      myNum = randomNum
    }

    return parseInt(myNum as string) <= requestNumMax
  }

  private getKey() {
    return this.WHITE_NUMBER_KEY_PREFIX + this.adtype.toLocaleUpperCase()
  }

  private getRandomInt = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
}

type AdType = 'content' | 'game'

export default AdRequestRate
